import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
function ConfigurationItemAccountAssignmentDialog(tabPage, parent) {
    var self = this;
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("400px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (!self.ValidateDialog()) {
                    return;
                }
                self.DialogResult("ok");
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogResult = ko.observable();
    self.ValidateDialog = function () {
        var isComplete = true;
        if (self.DialogViewModel.AccountAssignmentTypeId() == null) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(self.DialogViewModel.AccountAssignment())) {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.Show = function (configurationItemId, configurationItem200AccountAssignmentId) {
        tabPage.IsLoading(true);
        Bao.post("ConfigurationItemTab/ShowConfigurationItem200AccountAssignmentDialog", JSON.stringify({
            sessionTabId: parent.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: configurationItemId,
            configurationItem200AccountAssignmentId: configurationItem200AccountAssignmentId
        }), function (value) {
            ko.map.fromJS(value.Model, self.DialogViewModel, ko.dirtyFlag());
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            tabPage.IsLoading(false);
        });
    };
}
export default ConfigurationItemAccountAssignmentDialog;